module.exports = __webpack_public_path__ + "static/media/img_familia.077b05aa.jpg";